var React = require('react');

function LeftGolden (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#DFB676","fillRule":"evenodd","d":"M57.0939919,1451.13892 C111.840705,1443.95464 150.359146,1393.74462 143.127521,1338.99165 C135.895896,1284.23869 85.652447,1245.67681 30.9060081,1252.86108 C-23.8407053,1260.04536 -62.3591462,1310.25566 -55.1275213,1365.00835 C-47.8958964,1419.76131 2.34727858,1458.32319 57.0939919,1451.13892","transform":"translate(0 -1252)"}));
}

LeftGolden.defaultProps = {"width":"144","height":"200","viewBox":"0 0 144 200"};

module.exports = LeftGolden;

LeftGolden.default = LeftGolden;
